import { NoSaveAsPopupAction, NoSaveAsPopupActionKeys } from './actions';

export interface NoSaveAsPopupState {
	isDisplayed: boolean;
}

const initialState: NoSaveAsPopupState = {
	isDisplayed: false,
};

export function noSaveAsPopup(state: NoSaveAsPopupState = initialState, action: NoSaveAsPopupAction): NoSaveAsPopupState {
	switch (action.type) {
		case NoSaveAsPopupActionKeys.CLOSE:
			return {
				isDisplayed: false,
			};
		case NoSaveAsPopupActionKeys.OPEN:
			return {
				isDisplayed: true,
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NoSaveAsPopup/reducer.ts